webpackJsonp([0],{

/***/ "0DQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block__wrapper"},[_c('div',{staticClass:"block__content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column--right"},[_c('p',[_vm._v("\n           Amiraali Ahtio & Lemmen airue on helsinkiläinen bilebändi, joka tekee\n          juhlistasi täydelliset. Kun otat meihin yhteyttä, riittää että tiedät\n          juhliesi päivämäärän ja sijainnin: me jatkamme siitä.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Pyydä tarjous yhteydenottolomakkeella.")]),_vm._v(" "),_c('div',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#contact'),expression:"'#contact'"}],attrs:{"href":"#"}},[_vm._v("Ota yhteyttä")])]),_vm._v(" "),_c('div',{staticClass:"marginTop--extrasmall"},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#faq'),expression:"'#faq'"}],attrs:{"href":"#"}},[_vm._v("Usein kysytyt kysymykset")])]),_vm._v(" "),_c('p',{staticClass:"marginTop--medium",attrs:{"data-v-0abcaef8":""}},[_vm._v("Amiraali somessa:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column--left hideMobile"},[_c('h1',[_vm._v("Amiraali Ahtio & Lemmen airue")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"data-v-0abcaef8":"","href":"https://www.facebook.com/amiraaliahtio/","target":"_blank"}},[_c('img',{staticClass:"icon",attrs:{"data-v-0abcaef8":"","src":__webpack_require__("pUJY")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"data-v-0abcaef8":"","href":"https://www.instagram.com/amiraaliahtio/","target":"_blank"}},[_c('img',{staticClass:"icon marginLeft--extrasmall",attrs:{"data-v-0abcaef8":"","src":__webpack_require__("xW/j")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Eg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block__wrapper",attrs:{"id":"contact"}},[_c('div',{staticClass:"block__content"},[_c('h1',{staticClass:"alignCenter",attrs:{"id":"faq"}},[_vm._v("Usein kysytyt kysymykset:")]),_vm._v(" "),_c('div',{staticClass:"card__wrapper"},_vm._l((_vm.faqs),function(faq,index){return _c('div',{key:index,staticClass:"question"},[_c('h3',[_vm._v(_vm._s(faq.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(faq.answer))])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "21r3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_desktop_vue__ = __webpack_require__("UwFo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5864ca23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_desktop_vue__ = __webpack_require__("m3Lp");
function injectStyle (ssrContext) {
  __webpack_require__("sbwA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5864ca23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_desktop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5864ca23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_desktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ayk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5979":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block__wrapper"},[_c('div',{staticClass:"block__content"},[_c('h2',{staticClass:"alignCenter"},[_vm._v("Amiraali & Airue keikalla")]),_vm._v(" "),_c('div',{staticClass:"card__wrapper"},[_c('p',{staticClass:"bio__content"},[_vm._v("\n          Amiraali Ahtio & Lemmen airue on viiden ystävän perustama\n          helsinkiläinen bilebändi, joka on keikkaillut aktiivisesti jo\n          vuodesta 2014. Amiraalin pettämätön lavakarisma ja Lemmen airueen\n          tinkimätön yhteissoitto ovat kuljettaneet meidät lukuisiin\n          erilaisiin tilaisuuksiin, joista tyypillisimpiä ovat häät,\n          syntymäpäiväjuhlat ja pikkujoulut. Ohjelmistossamme on\n          musiikillisella taidolla – ja usein jopa sopivalla röyhkeydellä –\n          sovitettuja covereita klassikoista uusimpiin hitteihin. Amiraali\n          airueineen järjestää paikalle kaiken onnistuneisiin bileisiin\n          tarvittavan, jotta juhlijat voivat keskittyä viettämään\n          ikimuistoista päivää.\n        ")]),_vm._v(" "),_c('Testimonials'),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#contact'),expression:"'#contact'"}],staticClass:"button marginTop--medium"},[_vm._v("\n          Ota yhteyttä\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6zqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hero__wrapper"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "70+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Omm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BandsTable_js__ = __webpack_require__("Q3ZH");


var _name$data$mounted$co;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Tuo taulukkodata

/* harmony default export */ __webpack_exports__["a"] = (_name$data$mounted$co = {
  name: "Songs",
  data: function data() {
    return {
      loading: false,
      isMobile: false, // Alustetaan isMobile arvolla false
      randomArtist: "",
      randomSong: "",
      showResults: 12,
      showMore: true, // "Näytä lisää -teksti"
      bands: __WEBPACK_IMPORTED_MODULE_1__components_BandsTable_js__["a" /* bands */]
    };
  },
  mounted: function mounted() {
    this.generateRandomSong();
  },

  computed: {
    sortedBands: function sortedBands() {
      return this.bands.slice().sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$mounted$co, "mounted", function mounted() {
  this.countStats(); // Kutsutaan countStats-funktiota, kun komponentti on ladattu
  this.generateRandomSong();

  // Lisätään tapahtumankäsittelijä ikkunan koon muutoksille
  window.addEventListener("resize", this.checkIsMobile);

  // Kutsutaan tarkistusta aluksi
  this.checkIsMobile();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$mounted$co, "beforeDestroy", function beforeDestroy() {
  // Poistetaan tapahtumankäsittelijä komponentin purkamisen yhteydessä
  window.removeEventListener("resize", this.checkIsMobile);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$mounted$co, "methods", {
  // Funktio, joka tarkistaa selaimen leveyden ja päivittää isMobile-arvon
  checkIsMobile: function checkIsMobile() {
    this.isMobile = window.innerWidth < 800;
    console.log("Onko mobiili " + this.isMobile);
  },


  toggleResultFilter: function toggleResultFilter() {
    var that = this;

    if (this.showResults < this.bands.length) {
      this.showResults = this.bands.length;
      this.showMore = false;
    } else {
      setTimeout(function () {
        that.showResults = 12;
        this.showMore = true;
      }, 400);
    }
  },

  generateRandomSong: function generateRandomSong() {
    this.loading = true;
    this.randomArtist = "";
    this.randomSong = "";
    var that = this;
    var timeOut = Math.floor(Math.random() * 1200) + 750;
    setTimeout(function () {
      that.loading = false;
      var randomArtist = Math.floor(Math.random() * that.bands.length);
      that.randomArtist = that.bands[randomArtist].name;
      var randomSong = Math.floor(Math.random() * that.bands[randomArtist].songs.length);
      that.randomSong = that.bands[randomArtist].songs[randomSong].title;
    }, timeOut);
  },
  countStats: function countStats() {
    var finnishCount = 0;
    var englishCount = 0;
    var other = 0;

    for (var i = 0; i < this.bands.length; i++) {
      if (this.bands[i].language === "Finnish") {
        finnishCount++;
      } else if (this.bands[i].language === "English") {
        englishCount++;
      } else {
        other++;
      }
    }
    console.log("Suomenkielisiä artisteja:", finnishCount);
    console.log("Englanninkielisiä artisteja:", englishCount);
    console.log("Muut kielet:", other);
  }
}), _name$data$mounted$co);

/***/ }),

/***/ "7fkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero2_vue__ = __webpack_require__("Q6uJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ae233_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero2_vue__ = __webpack_require__("6zqW");
function injectStyle (ssrContext) {
  __webpack_require__("dfNp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-741ae233"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ae233_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8RCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Videowall_desktop_vue__ = __webpack_require__("21r3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Videowall_mobile_vue__ = __webpack_require__("UabH");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ParentKomponentti",
  components: {
    VideowallDesktop: __WEBPACK_IMPORTED_MODULE_0__components_Videowall_desktop_vue__["a" /* default */],
    VideowallMobile: __WEBPACK_IMPORTED_MODULE_1__components_Videowall_mobile_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isDesktop: window.innerWidth >= 800,
      isIOSNativeApp: /(iPod|iPhone|iPad)/.test(navigator.userAgent) && !window.MSStream
    };
  },
  created: function created() {
    // Tarkista näytön leveys ja päivitä isDesktop-muuttuja tarvittaessa
    window.addEventListener("resize", this.handleResize);
  },
  destroyed: function destroyed() {
    // Poista kuuntelija kun komponentti tuhotaan
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      // Päivitä isDesktop-muuttuja näytön leveyden perusteella
      this.isDesktop = window.innerWidth >= 800;
    }
  }
});

/***/ }),

/***/ "ANRe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIYSURBVHgB7dw7bhpRFAbgS2aadCzBPQ3ZQbyCZAdxVpAlRNlBsgN7By7TxVlBiAS9a6r0wJA7GCfY5jHjxtK53ychIZju/xGPezgpAQAAAAAAAAAAAAAAAAAAAAAAAAAA8MIGiSfG4/FwuVx+au/m2zDfruu6vppMJn9SMArwSA7/bLVa/Viv12e7jw8Gg9uqqt5EK0GV+OdQ+FvDpmlez+fz7ymQV4mNE+Hf+5CCUYDUOfzWMAVTfAF6hN+6ScEUXYCe4bcfBL+lYOpUqL7h5+s+TqfT6xRMkV8DnxP+bDa7TAEVVwDhP1RUAYT/VDEFEP5+RRRA+IeFL4DwjwtdAOGfFrYAwu8mZAGE3124Agi/n1AFaCd5cvi/hN9dqMOgpmkuhN9PtAK863Kd8P8LVYB8XNt1Xm+d2AhVgPzK/t3lulyUy9FoFG686zlCFaCu66/t9G6Xa5XgTqgCtCPbVVWdK0F3fghKm7eOi/yh8CoVyE/BW6WWwGHQjhJL4Dj4kdJKYCBkj5JKYCTsgFJKYCj0iBJKYCz8hOgl8MeQDiKXoNgFEUpwp+gNIX1LkJ1Pp9ObFEjR/w7OZwe3fc4Oss8pmOL3A/QswdsUjA0hqVcJwm0JU4CtLiXIz4XbD6AAO46VYLsm7ksKxp7APdpvB4vF4n0O/X7I9Gc7bRRxUSQAAAAAAAAAAAAAAAAAAAAAAAAAAAAv7i+3L8yFsJBbpgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "AkO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Testimonials_vue__ = __webpack_require__("hKE2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Bio",
  components: {
    Testimonials: __WEBPACK_IMPORTED_MODULE_0__components_Testimonials_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "C97P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DpAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "hero",
  data: function data() {
    return {
      parallax: {
        "background-position": "center top"
      }
    };
  },

  methods: {
    updateParallax: function updateParallax() {
      // Lasketaan taustakuvan sijainti vierityksen perusteella
      var scrollTop = window.pageYOffset;
      this.parallax["background-position"] = "center " + -scrollTop * 0.1 + "px"; // Säädä kerroin (0.2) haluamallasi nopeudella
    }
  },
  mounted: function mounted() {
    // Kutsutaan updateParallax-funktiota vierityksen yhteydessä
    window.addEventListener("scroll", this.updateParallax);
  },
  beforeDestroy: function beforeDestroy() {
    // Poistetaan kuuntelija komponentin tuhoutuessa
    window.removeEventListener("scroll", this.updateParallax);
  }
});

/***/ }),

/***/ "DtRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hero__wrapper",style:(_vm.parallax)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero__content"},[_c('h1',{staticClass:"light"},[_vm._v("Bilebändi")]),_vm._v(" "),_c('h1',{staticClass:"light"},[_vm._v("Amiraali Ahtio")]),_vm._v(" "),_c('h1',{staticClass:"light"},[_vm._v("& Lemmen airue")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EMFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("gjb/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6049382e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("1Eg6");
function injectStyle (ssrContext) {
  __webpack_require__("nI4J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6049382e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6049382e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G5uk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GbYR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H9iu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video-all-small.c5eaf9a.mp4";

/***/ }),

/***/ "I5Xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "block1",
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "IEpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J1ig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDesktop)?_c('VideowallDesktop'):(!_vm.isIOSNativeApp)?_c('VideowallMobile'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5421b3f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IEpK");
function injectStyle (ssrContext) {
  __webpack_require__("G5uk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5421b3f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_main_css__ = __webpack_require__("asJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_main_css__);
/*
 The Vue build version to load with the `import` command
 (runtime-only or standalone) has been set in webpack.base.conf with an alias.
 */






var VueScrollTo = __webpack_require__("bm7V");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OiDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bio_vue__ = __webpack_require__("AkO8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0681e458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bio_vue__ = __webpack_require__("5979");
function injectStyle (ssrContext) {
  __webpack_require__("PrLQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0681e458"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0681e458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PrLQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q3ZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bands; });
var bands = [{
  name: "Bruno Mars",
  songs: [{
    title: "Uptown Funk"
  }],
  language: "English"
}, {
  name: "STIG",
  songs: [{
    title: "Roy Orbison"
  }],
  language: "Finnish"
}, {
  name: "Coldplay",
  songs: [{
    title: "Feelslikeimfallinginlove"
  }],
  language: "English"
}, {
  name: "Ramses II",
  songs: [{
    title: "Villi Eläin"
  }],
  language: "Finnish"
}, {
  name: "Käärijä",
  songs: [{
    title: "Cha Cha Cha"
  }, { title: "Ruoska" }],
  language: "Finnish"
}, {
  name: "Bruce Springsteen",
  songs: [{
    title: "Dancing In The Dark"
  }],
  language: "English"
}, {
  name: "Gasellit",
  songs: [{
    title: "Imus"
  }],
  language: "Finnish"
}, {
  name: "Ed Sheeran",
  songs: [{
    title: "Perfect"
  }, {
    title: "Shape of You"
  }],
  language: "English"
}, {
  name: "Portion Boys",
  songs: [{
    title: "Vauhti Kiihtyy"
  }],
  language: "Finnish"
}, {
  name: "Antti Tuisku",
  songs: [{
    title: "Hyökyaalto"
  }, {
    title: "Rahan takii"
  }],
  language: "Finnish"
}, {
  name: "Lauri Tähkä",
  songs: [{
    title: "Nukkuvat aamut"
  }],
  language: "Finnish"
}, {
  name: "Outkast",
  songs: [{
    title: "Hey Ya!"
  }],
  language: "English"
}, {
  name: "Olavi Uusivirta",
  songs: [{
    title: "On niin helppo olla onnellinen"
  }, {
    title: "Kultaa hiuksissa"
  }],
  language: "Finnish"
}, {
  name: "Muse",
  songs: [{
    title: "Starlight"
  }],
  language: "English"
}, {
  name: "MGMT",
  songs: [{
    title: "Kids"
  }],
  language: "English"
}, {
  name: "Virve Rosti",
  songs: [{
    title: "Sata salamaa"
  }],
  language: "Finnish"
}, {
  name: "Kirka",
  songs: [{
    title: "Hetki lyö"
  }, {
    title: "Pääsi rinnallein painuu"
  }, {
    title: "Hengaillaan"
  }],
  language: "Finnish"
}, {
  name: "Neil Young",
  songs: [{
    title: "Harvest Moon"
  }],
  language: "English"
}, {
  name: "YOUNGHEARTED",
  songs: [{
    title: "Hyvä näin"
  }],
  language: "Finnish"
}, {
  name: "Beyoncé",
  songs: [{
    title: "Crazy In Love"
  }],
  language: "English"
}, {
  name: "Van Morrison",
  songs: [{
    title: "Moondance"
  }],
  language: "English"
}, {
  name: "Jarkko Martikainen",
  songs: [{
    title: "Valssi tanssitaidottomille"
  }],
  language: "Finnish"
}, {
  name: "JVG",
  songs: [{
    title: "Häissä"
  }],
  language: "Finnish"
}, {
  name: "Anssi Kela",
  songs: [{
    title: "1972"
  }],
  language: "Finnish"
}, {
  name: "The Doors",
  songs: [{
    title: "Hello, I Love You"
  }],
  language: "English"
}, {
  name: "BEHM",
  songs: [{
    title: "Hei rakas"
  }],
  language: "Finnish"
}, {
  name: "Henry Mancini",
  songs: [{
    title: "Moon River"
  }],
  language: "English"
}, {
  name: "Blondie",
  songs: [{
    title: "Maria"
  }],
  language: "English"
}, {
  name: "The Doobie Brothers",
  songs: [{
    title: "Long Train Runnin"
  }],
  language: "English"
}, {
  name: "Chuck Berry",
  songs: [{
    title: "You Never Can Tell"
  }],
  language: "English"
}, {
  name: "Hurriganes",
  songs: [{
    title: "Get On"
  }],
  language: "Finnish"
}, {
  name: "Juha Tapio",
  songs: [{
    title: "Mä tykkään susta niin että halkeen"
  }],
  language: "Finnish"
}, {
  name: "Tuure Kilpeläinen",
  songs: [{
    title: "Autiosaari"
  }],
  language: "Finnish"
}, {
  name: "Leevi And The Leavings",
  songs: [{
    title: "Amalia"
  }, {
    title: "Pohjois-Karjala"
  }],
  language: "Finnish"
}, {
  name: "Elvis Presley",
  songs: [{
    title: "Jailhouse Rock"
  }, {
    title: "Can't Help Falling In Love"
  }],
  language: "English"
}, {
  name: "J. Karjalainen",
  songs: [{
    title: "Villejä Lupiineja"
  }, {
    title: "Sekaisin"
  }],
  language: "Finnish"
}, {
  name: "Jefferson Airplane",
  songs: [{
    title: "Somebody To Love"
  }],
  language: "English"
}, {
  name: "The Sounds",
  songs: [{
    title: "Living in America"
  }],
  language: "English"
}, {
  name: "Miljoonasade",
  songs: [{
    title: "Marraskuu"
  }],
  language: "Finnish"
}, {
  name: "fun.",
  songs: [{
    title: "We Are Young"
  }],
  language: "English"
}, {
  name: "Madonna",
  songs: [{
    title: "Like A Virgin"
  }],
  language: "English"
}, {
  name: "Duran Duran",
  songs: [{
    title: "Ordinary World"
  }],
  language: "English"
}, {
  name: "Ville Valo",
  songs: [{
    title: "Olet mun kaikuluotain"
  }],
  language: "Finnish"
}, {
  name: "Tapio Rautavaara",
  songs: [{
    title: "Uralin pihlaja"
  }],
  language: "Finnish"
}, {
  name: "Bloodhound Gang",
  songs: [{
    title: "Bad Touch"
  }],
  language: "English"
}, {
  name: "Kari Kuuva",
  songs: [{
    title: "Tango pelargonia"
  }],
  language: "Finnish"
}, {
  name: "Bon Jovi",
  songs: [{
    title: "Runaway"
  }, {
    title: "Always"
  }],
  language: "English"
}, {
  name: "Sir Elwoodin Hiljaiset Värit",
  songs: [{
    title: "Älä mee"
  }],
  language: "Finnish"
}, {
  name: "Pelle Miljoona",
  songs: [{
    title: "Tahdon rakastella sinua"
  }],
  language: "Finnish"
}, {
  name: "Queen",
  songs: [{
    title: "Crazy Little Thing Called Love"
  }, {
    title: "Don't Stop Me Now"
  }],
  language: "English"
}, {
  name: "Guns N’ Roses",
  songs: [{
    title: "November Rain, Welcome To The Jungle"
  }],
  language: "English"
}, {
  name: "Of Monsters and Men",
  songs: [{
    title: "Little Talks"
  }],
  language: "English"
}, {
  name: "Blur",
  songs: [{
    title: "Song 2"
  }],
  language: "English"
}, {
  name: "Asa",
  songs: [{
    title: "Taulu"
  }],
  language: "Finnish"
}, {
  name: "Dominik Hauser",
  songs: [{
    title: "Love Boat"
  }],
  language: "English"
}, {
  name: "Desireless",
  songs: [{
    title: "Voyage Voyage"
  }],
  language: "French"
}, {
  name: "Rage Against The Machine",
  songs: [{
    title: "Killing In The Name"
  }],
  language: "English"
}, {
  name: "Bombfunk MC's",
  songs: [{
    title: "Freestyler"
  }],
  language: "English"
}, {
  name: "Antti Autio",
  songs: [{
    title: "Pihkassa"
  }],
  language: "Finnish"
}, {
  name: "Marilii",
  songs: [{
    title: "Nautin elämästä"
  }],
  language: "Finnish"
}, {
  name: "Pekka Ruuska",
  songs: [{
    title: "Rafaelin enkeli"
  }],
  language: "Finnish"
}, {
  name: "The Proclaimers",
  songs: [{
    title: "I'm Gonna Be (500 Miles)"
  }],
  language: "Scottish"
}, {
  name: "Pate Mustajärvi",
  songs: [{
    title: "Ukkometso"
  }],
  language: "Finnish"
}, {
  name: "Neil Diamond",
  songs: [{
    title: "Sweet Caroline"
  }],
  language: "English"
}, {
  name: "Hector",
  songs: [{
    title: "Juodaan viinaa"
  }, {
    title: "Yhtenä iltana"
  }],
  language: "Finnish"
}, {
  name: "Foo Fighters",
  songs: [{
    title: "Pretender"
  }],
  language: "English"
}, {
  name: "Rauli Badding Somerjoki",
  songs: [{
    title: "Ikkunaprinsessa"
  }, {
    title: "Valot"
  }, {
    title: "Paratiisi"
  }],
  language: "Finnish"
}, {
  name: "Topi Sorsakoski",
  songs: [{
    title: "Cherbourgin sateenvarjot"
  }],
  language: "Finnish"
}, {
  name: "Apulanta",
  songs: [{
    title: "Piiskaa"
  }],
  language: "Finnish"
}, {
  name: "Jack Johnson",
  songs: [{
    title: "Better Together"
  }],
  language: "English"
}, {
  name: "22-pistepirkko",
  songs: [{
    title: "Birdy"
  }],
  language: "Finnish"
}, {
  name: "Tuomari Nurmio",
  songs: [{
    title: "Lasten mehuhetki"
  }],
  language: "Finnish"
}, {
  name: "Anna Puu",
  songs: [{
    title: "Kolme vuodenaikaa"
  }],
  language: "Finnish"
}, {
  name: "Dingo",
  songs: [{
    title: "Levoton tuhkimo"
  }, {
    title: "Autiotalo"
  }],
  language: "Finnish"
}, {
  name: "Adele",
  songs: [{
    title: "Rolling In The Deep"
  }],
  language: "English"
}, {
  name: "Tiktak",
  songs: [{
    title: "Heilutaan"
  }],
  language: "Finnish"
}, {
  name: "Tehosekoitin",
  songs: [{
    title: "Pillitä Elli pillitä"
  }, {
    title: "Kaikki nuoret tyypit"
  }],
  language: "Finnish"
}, {
  name: "Aki Sirkesalo",
  songs: [{
    title: "Naispaholainen"
  }],
  language: "Finnish"
}, {
  name: "The Killers",
  songs: [{
    title: "Human"
  }],
  language: "English"
}, {
  name: "Red Hot Chili Peppers",
  songs: [{
    title: "Can't Stop"
  }],
  language: "English"
}, {
  name: "Eppu Normaali",
  songs: [{
    title: "Vihreä joen rannalla"
  }],
  language: "Finnish"
}, {
  name: "Toto",
  songs: [{
    title: "Africa"
  }],
  language: "English"
}, {
  name: "Roxette",
  songs: [{
    title: "Sleeping In My Car"
  }],
  language: "Swedish"
}, {
  name: "Pepe Willberg",
  songs: [{
    title: "Aamu"
  }, {
    title: "Elämältä kaiken sain"
  }],
  language: "Finnish"
}, {
  name: "Stevie Wonder",
  songs: [{
    title: "I Wish"
  }],
  language: "English"
}, {
  name: "Samuli Edelmann",
  songs: [{
    title: "Peggy"
  }],
  language: "Finnish"
}, {
  name: "Metallica",
  songs: [{
    title: "Nothing Else Matters"
  }],
  language: "English"
}, {
  name: "Rihanna",
  songs: [{
    title: "Umbrella"
  }],
  language: "English"
}, {
  name: "The Beatles",
  songs: [{
    title: "Hey Jude"
  }],
  language: "English"
}, {
  name: "Haddaway",
  songs: [{
    title: "What Is Love"
  }],
  language: "English"
}, {
  name: "David Bowie",
  songs: [{
    title: "Life On Mars"
  }, {
    title: "The Man Who Sold The World"
  }],
  language: "English"
}, {
  name: "Matti ja Teppo",
  songs: [{
    title: "Kaiken takana on nainen"
  }, {
    title: "Mä joka päivä töitä teen"
  }],
  language: "Finnish"
}, {
  name: "Popeda",
  songs: [{
    title: "Repe ja Lissu"
  }],
  language: "Finnish"
}, {
  name: "Pekka Streng",
  songs: [{
    title: "Puutarhassa"
  }, {
    title: "Perhonen"
  }],
  language: "Finnish"
}, {
  name: "Neon 2",
  songs: [{
    title: "Kemiaa"
  }],
  language: "Finnish"
}, {
  name: "Pulp",
  songs: [{
    title: "Disco 2000"
  }],
  language: "English"
}, {
  name: "The Black Keys",
  songs: [{
    title: "Lonely Boy"
  }],
  language: "English"
}, {
  name: "Abba",
  songs: [{
    title: "Does Your Mother Know?"
  }, {
    title: "Dancing Queen"
  }, {
    title: "Gimme! Gimme! Gimme! (A Man After Midnight)"
  }],
  language: "Swedish"
}, {
  name: "Elton John",
  songs: [{
    title: "Something About the Way You Look Tonight"
  }, {
    title: "I'm Still Standing"
  }],
  language: "English"
}, {
  name: "Smash Mouth",
  songs: [{
    title: "I'm a Believer"
  }],
  language: "English"
}, {
  name: "Petshop Boys",
  songs: [{
    title: "Always on My Mind"
  }],
  language: "English"
}, {
  name: "Egotrippi",
  songs: [{
    title: "Varovasti nyt"
  }],
  language: "Finnish"
}, {
  name: "U2",
  songs: [{
    title: "Beautiful Day"
  }],
  language: "English"
}, {
  name: "Karri Koira",
  songs: [{
    title: "Ne kutsuu mua koiraks"
  }],
  language: "Finnish"
}, {
  name: "Karri Koira",
  songs: [{
    title: "Ne kutsuu mua koiraks"
  }],
  language: "Finnish"
}, {
  name: "Erika Vikman",
  songs: [{
    title: "Ruoska"
  }],
  language: "Finnish"
}, {
  name: "Sting",
  songs: [{
    title: "Fields Of Gold"
  }],
  language: "English"
}, {
  name: "Tom Jones",
  songs: [{
    title: "It's Not Unusual"
  }],
  language: "English"
}, {
  name: "Robin Packalen",
  songs: [{
    title: "Häitä pidelly"
  }],
  language: "Finnish"
}, {
  name: "Brtiney Spears",
  songs: [{
    title: "Toxic"
  }],
  language: "English"
}, {
  name: "Haloo Helsinki",
  songs: [{
    title: "Reiviluola"
  }],
  language: "Finnish"
}];

/***/ }),

/***/ "Q6uJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "hero",
  data: function data() {
    return {
      parallax: {
        "background-position": "center top"
      }
    };
  },

  methods: {
    updateParallax: function updateParallax() {
      // Lasketaan taustakuvan sijainti vierityksen perusteella
      var scrollTop = window.pageYOffset;
      this.parallax["background-position"] = "center " + -scrollTop * 0.1 + "px"; // Säädä kerroin (0.2) haluamallasi nopeudella
    }
  },
  mounted: function mounted() {
    // Kutsutaan updateParallax-funktiota vierityksen yhteydessä
    window.addEventListener("scroll", this.updateParallax);
  },
  beforeDestroy: function beforeDestroy() {
    // Poistetaan kuuntelija komponentin tuhoutuessa
    window.removeEventListener("scroll", this.updateParallax);
  }
});

/***/ }),

/***/ "RP/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hero-container"},[(!_vm.videoLoaded)?_c('div',{staticClass:"preloader"}):(_vm.loadingProgress < 100)?_c('div',{staticClass:"video-loading"},[_c('p',[_vm._v("Ladataan...")])]):_vm._e(),_vm._v(" "),_c('video',{ref:"video",staticClass:"hero-video",attrs:{"autoplay":"","loop":"","preload":"metadata","playsinline":""},on:{"loadedmetadata":_vm.initializeVideo,"loadeddata":function($event){_vm.videoLoaded = true},"canplaythrough":_vm.videoCanPlayThrough}},[_c('source',{attrs:{"src":_vm.videoFile,"type":"video/mp4"}}),_vm._v("\n      Your browser does not support the video tag.\n    ")]),_vm._v(" "),_c('div',{staticClass:"hero-overlay"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UabH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_mobile_vue__ = __webpack_require__("mC4Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39919b7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_mobile_vue__ = __webpack_require__("RP/D");
function injectStyle (ssrContext) {
  __webpack_require__("70+W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39919b7d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_mobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39919b7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UfZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__("DpAH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd21e52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__("DtRh");
function injectStyle (ssrContext) {
  __webpack_require__("debb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd21e52a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd21e52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UvP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hero_vue__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Hero2_vue__ = __webpack_require__("7fkm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Videowall_vue__ = __webpack_require__("vfXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Block1_vue__ = __webpack_require__("WFXD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Songs_vue__ = __webpack_require__("jUAq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Bio_vue__ = __webpack_require__("OiDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Faq_vue__ = __webpack_require__("EMFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactForm_vue__ = __webpack_require__("wCbp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_Hero_vue__["a" /* default */],
    Hero2: __WEBPACK_IMPORTED_MODULE_1__components_Hero2_vue__["a" /* default */],
    Videowall: __WEBPACK_IMPORTED_MODULE_2__components_Videowall_vue__["a" /* default */],
    Block1: __WEBPACK_IMPORTED_MODULE_3__components_Block1_vue__["a" /* default */],
    Songs: __WEBPACK_IMPORTED_MODULE_4__components_Songs_vue__["a" /* default */],
    Bio: __WEBPACK_IMPORTED_MODULE_5__components_Bio_vue__["a" /* default */],
    Faq: __WEBPACK_IMPORTED_MODULE_6__components_Faq_vue__["a" /* default */],
    ContactForm: __WEBPACK_IMPORTED_MODULE_7__components_ContactForm_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "UwFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoFile: "", // Videon polku
      videoLoaded: false, // Lisää tieto video-latauksen tilasta
      loadingProgress: 0 // Latauksen edistyminen prosentteina
    };
  },

  methods: {
    initializeVideo: function initializeVideo() {
      var videoPlayer = this.$refs.video;
      videoPlayer.volume = 0; // Aseta äänenvoimakkuus nollaan
      // Älä aloita videon toistoa tässä
    },
    playVideo: function playVideo() {
      var videoPlayer = this.$refs.video;
      videoPlayer.play();
    },
    videoCanPlayThrough: function videoCanPlayThrough() {
      // Tässä vaiheessa video on ladattu ja voi toistua turvallisesti
      this.playVideo();
    },
    updateLoadingProgress: function updateLoadingProgress() {
      var videoPlayer = this.$refs.video;
      if (videoPlayer) {
        var loaded = videoPlayer.buffered.end(0); // Ladattu osuus videosta
        var duration = videoPlayer.duration; // Videon kesto
        this.loadingProgress = loaded / duration * 100;
      }
    }
  },
  mounted: function mounted() {
    this.videoFile = __webpack_require__("H9iu");

    // Päivitä latauspalkkia 500 millisekunnin välein
    setInterval(this.updateLoadingProgress, 500);
  }
});

/***/ }),

/***/ "VOhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"testimonial__wrapper",on:{"mousedown":_vm.handleMouseDown,"mousemove":_vm.handleMouseMove,"mouseup":_vm.handleMouseUp}},[_c('div',{staticClass:"testimonial--button",on:{"click":_vm.previousTestimonial}},[_c('img',{staticClass:"arrow left",attrs:{"src":__webpack_require__("ANRe"),"alt":"Edellinen"}})]),_vm._v(" "),_c('div',{staticClass:"testimonial"},[_c('p',{staticClass:"review"},[_vm._v("\""+_vm._s(_vm.currentTestimonial.review)+"\"")]),_vm._v(" "),_c('p',{staticClass:"customer"},[(_vm.currentTestimonial.href)?_c('a',{attrs:{"target":"_blank","href":_vm.currentTestimonial.href}},[_vm._v(_vm._s(_vm.currentTestimonial.customer))]):_c('span',[_vm._v(_vm._s(_vm.currentTestimonial.customer))])])]),_vm._v(" "),_c('div',{staticClass:"testimonial--button",on:{"click":_vm.nextTestimonial}},[_c('img',{staticClass:"arrow right",attrs:{"src":__webpack_require__("liws"),"alt":"Seuraava"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VZrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("UvP+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adb599c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("wWxR");
function injectStyle (ssrContext) {
  __webpack_require__("C97P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adb599c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VfpV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video-all-mobile.c12c60a.mp4";

/***/ }),

/***/ "WFXD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Block1_vue__ = __webpack_require__("I5Xh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2005b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Block1_vue__ = __webpack_require__("0DQI");
function injectStyle (ssrContext) {
  __webpack_require__("GbYR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe2005b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Block1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2005b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Block1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Main__ = __webpack_require__("VZrM");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Main__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zw9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block__wrapper",attrs:{"id":"element"}},[_c('div',{staticClass:"block__content"},[_c('h2',{staticClass:"alignCenter"},[_vm._v("Amiraalin keikoilla soitettua:")]),_vm._v(" "),_c('div',{staticClass:"mysteryBox"},[_c('p',{staticClass:"alignCenter"},[_vm._v("\n          "+_vm._s(_vm.randomArtist)+" "),(!_vm.loading)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.randomSong)+"\n        ")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"alignCenter mysteryBox__links"},[(!_vm.loading)?_c('a',{staticClass:"clickable",on:{"click":function($event){return _vm.generateRandomSong()}}},[_vm._v("Selaa kappaleita")]):_c('p',[_vm._v("Haetaan...")])]),_vm._v(" "),_c('h4',{staticClass:"alignCenter marginTop--large"},[_vm._v("\n        Ahtion settilistalla on ollut mm. seuraavia artisteja:\n      ")]),_vm._v(" "),_c('div',{staticClass:"band__wrapper"},_vm._l((_vm.sortedBands),function(band,index){return (index < _vm.showResults)?_c('div',{key:index,staticClass:"band__label"},[_c('p',{staticClass:"primary"},[_vm._v(_vm._s(band.name))])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"marginTop--medium"},[(_vm.showMore)?_c('div',{staticClass:"button",on:{"click":function($event){return _vm.toggleResultFilter()}}},[_vm._v("\n          Näytä lisää\n        ")]):_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#element'),expression:"'#element'"}],staticClass:"button",on:{"click":function($event){return _vm.toggleResultFilter()}}},[_vm._v("\n          Näytä vähemmän\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "asJK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bnVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "debb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dfNp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer__wrapper",attrs:{"id":"contact"}},[_c('div',{staticClass:"footer__content"},[_c('h1',{staticClass:"light alignCenter"},[_vm._v("Ota yhteyttä")]),_vm._v(" "),_c('div',{staticClass:"form__wrapper"},[_c('p',{staticClass:"light alignCenter",attrs:{"data-v-66475aa5":""}},[_vm._v("\n          Keikkakyselyt ja muut kysymykset tätä kautta. Rohkeasti vaan! Lue\n          myös "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#faq'),expression:"'#faq'"}],attrs:{"href":"#"}},[_vm._v("usein kysytyt kysymykset")]),_vm._v(".\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"https://formspree.io/f/amiraaliahtio@gmail.com","method":"POST"}},[_c('input',{attrs:{"type":"name","name":"name","placeholder":"Nimesi"}}),_vm._v(" "),_c('input',{staticClass:"marginTop--small",attrs:{"type":"email","name":"email","placeholder":"Sähköpostiosoitteesi","required":""}}),_vm._v(" "),_c('input',{staticClass:"marginTop--small",attrs:{"type":"phone","name":"phone","placeholder":"Puhelinnumerosi (valinnainen)"}}),_vm._v(" "),_c('textarea',{staticClass:"marginTop--small",attrs:{"rows":"5","name":"message","placeholder":"Viestisi"}}),_vm._v(" "),_c('p',{staticClass:"light alignCenter"},[_vm._v("\n            Vastaamme jokaiseen yhteydenottoon; "),_c('br'),_vm._v("\n            jos et kuule meistä muutamaan päivään, tarkistathan sähköpostisi\n            roska- ja mainoslaatikon.\n          ")]),_vm._v(" "),_c('div',{staticClass:"marginTop--medium"},[_c('button',{attrs:{"type":"submit"}},[_vm._v("Lähetä")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"light alignCenter marginTop--medium"},[_vm._v("\n          ps. Meidät tavoittaa myös\n          "),_c('a',{attrs:{"href":"https://www.instagram.com/amiraaliahtio/","target":"_blank"}},[_vm._v("\n            Instagramista")]),_vm._v("\n          ja\n          "),_c('a',{attrs:{"href":"https://www.facebook.com/amiraaliahtio/","target":"_blank"}},[_vm._v("Facebookista")]),_vm._v(".\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gjb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      faqs: [{
        title: "Millaisissa tapahtumissa soitatte?",
        answer: "Melkein missä tahansa: tyypilliset esiintymisemme ovat häissä, yritysten pikkujouluissa tai syntymäpäivillä. Emme ole ronkeleita."
      }, {
        title: "Mitä saan rahoillani?",
        answer: "Huikeat bileet! Lähtökohtaisesti soitamme keikoillamme kolme 45min settiä. Tuomme mukanamme kaiken tarvittavan: soittimet, äänentoistolaitteiston, ääniteknikon ja valot. Pyydä tarjous yhteydenottolomakkeen kautta."
      }, {
        title: "Saanko toivoa biisejä?",
        answer: "Tottakai! Rakennamme keikkamme rungon itse tilaajan antamien suuntaviivojen pohjalta, mutta myös täsmätoivebiisit ovat aina tervetulleita."
      }, {
        title: "Onko esiintymisellenne maantieteellisiä rajoitteita?",
        answer: "Ei: meidät voi tilata esiintymään mihin tahansa Suomessa. Lisäämme vain matkakustannuksemme esiintymispalkkiomme päälle."
      }, {
        title: "Miten maksu hoituu?",
        answer: "Toimitamme tilaajalle laskun esiintymispalkkiostamme keikan jälkeen."
      }, {
        title: "Mitä soittimia teillä on bändissänne?",
        answer: "Vakiokokoonpanossamme meillä on laulun ja taustalaulujen lisäksi akustinen kitara, sähkökitara, basso, koskettimet ja rummut."
      }]
    };
  }
});

/***/ }),

/***/ "hKE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testimonials_vue__ = __webpack_require__("jk8Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5e3a2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonials_vue__ = __webpack_require__("VOhs");
function injectStyle (ssrContext) {
  __webpack_require__("nCko")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e5e3a2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testimonials_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5e3a2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jUAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Songs_vue__ = __webpack_require__("7Omm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e4cd6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Songs_vue__ = __webpack_require__("Zw9x");
function injectStyle (ssrContext) {
  __webpack_require__("la/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e4cd6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Songs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e4cd6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Songs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jk8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      testimonials: [{
        review: "Tunnelma oli teidän ansioista vielä parempi kuin oltais edes osattu toivoa. Tää oli ihan mielettömän hieno juttu!",
        customer: "Selma & Hannes"
      }, {
        review: "Amiraali Ahtio on loistava bilebändi! Häissämme bändin energinen esiintyminen ja hyvät soittolistat takasivat sen, että tunnelma pysyi huipussaan pitkälle yöhön asti.",
        customer: "Maria"
      }, {
        review: "Wooow mikä bändi - ehkä rakastuin just",
        customer: "Sabina"
      }, {
        review: "Älyttömän kova meininki! Kaikilta häävierailta tuli vain positiivista palautetta. Myös käytännön järjestelyjen osalta kaikki oli mutkatonta.",
        customer: "Santtu & Juulia"
      }, {
        review: "Kerran vielä kiitos mahtavasta showsta, teitte juhlista upeat.",
        customer: "Matias & Mari"
      }, {
        review: "Olitte ihan täydellinen bändi - iso kiitos vielä! Tulemma kyllä vinkkaamaan teistä kaikille 😉",
        customer: "Henniina & Sampo"
      }, {
        review: "Ihan mielettömät kiitokset teille huikeesta setistä!!! Bändi oli monen mielestä illan paras juttu ja musiikki oli erinomaista, olette kyllä super taitavia kaikki.",
        customer: "Jannika"
      }, {
        review: "Saatiin bändistä erittäin paljon kehuja vierailta ja olette ne kaikki ansainneet! Kiitos =)",
        customer: "Sami"
      }, {
        review: "Kiitos vielä tuhannesti! Olitte loistavia!",
        customer: "Joni"
      }, {
        review: "Heippa ja valtavan iso kiitos aivan älyttömän hyvästä keikasta! Saatiin myös vierailta runsaasti kehuja teistä, joidenkin kohdalla useampaankin otteeseen.",
        customer: "Tuuli ja Henri"
      }, {
        review: "Kiitos teille! Ei olisi voinut toivoa parempaa!",
        customer: "Maija & Olli"
      }, {
        review: "Aivan huikea tunnelman nostattaja on tämä bändi. Saa hetkessä tanssimaan kaikki juhlijat taaperosta vaariin. Suosittelemme lämpimästi!",
        customer: "Raija"
      }, {
        review: "Kiitos erinomaisesta setistä ja bileistä. Porukka oli todella fiiliksissä ja kyselivät että mistä tällainen bändi on oikeen löytynyt!",
        customer: "Janne & Outi"
      }, {
        review: "On suuri ilo tehdä yhteistyötä ammatitaitoisen ja superhauskan bändin kanssa! Jos haluat vauhtia tanssilattialla, tämä bändi on sinulle.",
        customer: "Juhlakirsikka",
        href: "https://juhlakirsikka.fi/"
      }, {
        review: "Teitte hääjuhlistamme unohtumattomat!",
        customer: "Irina & Jesse"
      }, {
        review: "Suurkiitokset, kun tulitte — teitte illan bileistä aivan huikeat!",
        customer: "Henna"
      }],
      currentTestimonialIndex: 0,
      touchStartX: 0,
      touchEndX: 0,
      isDragging: false
    };
  },

  computed: {
    currentTestimonial: function currentTestimonial() {
      return this.testimonials[this.currentTestimonialIndex];
    }
  },
  methods: {
    previousTestimonial: function previousTestimonial() {
      this.resetTimer();
      if (this.currentTestimonialIndex > 0) {
        this.currentTestimonialIndex--;
      } else {
        this.currentTestimonialIndex = this.testimonials.length - 1;
      }
    },
    nextTestimonial: function nextTestimonial() {
      this.resetTimer();
      if (this.currentTestimonialIndex < this.testimonials.length - 1) {
        this.currentTestimonialIndex++;
      } else {
        this.currentTestimonialIndex = 0;
      }
    },
    randomizeTestimonial: function randomizeTestimonial() {
      this.resetTimer();
      var randomIndex = Math.floor(Math.random() * this.testimonials.length);
      this.currentTestimonialIndex = randomIndex;
    },
    startTimer: function startTimer() {
      this.timer = setInterval(this.nextTestimonial, 8000);
    },
    resetTimer: function resetTimer() {
      clearInterval(this.timer);
      this.startTimer();
    },
    handleTouchStart: function handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].clientX;
    },
    handleTouchEnd: function handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      var deltaX = this.touchEndX - this.touchStartX;
      if (deltaX > 50) {
        this.previousTestimonial();
      } else if (deltaX < -50) {
        this.nextTestimonial();
      }
    },
    handleMouseDown: function handleMouseDown(event) {
      this.isDragging = true;
      this.mouseStartX = event.clientX;
    },
    handleMouseMove: function handleMouseMove(event) {
      if (!this.isDragging) return;
      var deltaX = event.clientX - this.mouseStartX;
      if (deltaX > 50) {
        this.previousTestimonial();
        this.isDragging = false;
      } else if (deltaX < -50) {
        this.nextTestimonial();
        this.isDragging = false;
      }
    },
    handleMouseUp: function handleMouseUp() {
      this.isDragging = false;
    }
  },
  mounted: function mounted() {
    this.startTimer(); // Aloita ajastin
    this.randomizeTestimonial(); // Näytä satunnainen testimonial aluksi
    // Lisää touch-tapahtumankäsittelijät
    this.$el.addEventListener("touchstart", this.handleTouchStart);
    this.$el.addEventListener("touchend", this.handleTouchEnd);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    // Poista touch-tapahtumankäsittelijät
    this.$el.removeEventListener("touchstart", this.handleTouchStart);
    this.$el.removeEventListener("touchend", this.handleTouchEnd);
  }
});

/***/ }),

/***/ "la/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "liws":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIiSURBVHgB7dxNTlNRGMfhU3sHDpmRMGJOmuAKxB2wA2UFLEFdibACYQWyhCawgDJrOnKoST88JyXWft860bzneRIScnsY/X+Qlts0JQAAAAAAAAAAAAAAAAAAAAAAAAAAAP6xTgro/Pz8aDweX+dvL14u3TVNc9/v9weJJeECyOOfTiaTb7PZ7PTP651OZ9Dtdt+JYNmrFEwe/+Pq+EW5VsIogSR+CxdAHvpyx2MiWBEugOxo14MiWBYxgId9B0SwEDGAz20OiWAuXABPT08P+Rn/VZuzIgj6f4Ci1+t9yAN/aXO25peIYQMoRLBf6AAKEewWPoBCBNtVEUAhgs2qCaAQwbqqAihEsKy6AAoRLFQZQCGCuWoDKERQeQDFX0TwJkfwPQXRTZUbjUb94+Pj5/ztZYvjR9Pp9Gf+mYcURMS7gQd7fHy8aXsDKXubAhHAi/ybPUsVEkB2dnb2Pv8FuGlzNj9fuE+BNKlyh4xfngQ2TXOXAqn6VcCh43sZGIjx56oMwPgL1QVg/GVVBWD8ddUEYPzNqgjA+NuFD8D4u4UOwPj7hQ3A+O2EDMD47YULoNfrXeYbNl/bnPWpITE/IOK6zTnjz0W8HXyx74DxFyIGsPP9esZfFjGA220PGH9duACapvlUhl69bvzNwr0reDgc/jg5ObmfTCbPefTX+dIgf93mMK7y+MMEAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5dfCglGtLUc9A4AAAAASUVORK5CYII="

/***/ }),

/***/ "m3Lp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hero-container"},[(!_vm.videoLoaded)?_c('div',{staticClass:"preloader"}):(_vm.loadingProgress < 100)?_c('div',{staticClass:"video-loading"},[_c('div',{staticClass:"progress-bar"},[_c('div',{style:({ width: _vm.loadingProgress + '%' })})]),_vm._v(" "),_c('p',[_vm._v("Ladataan... "+_vm._s(Math.floor(_vm.loadingProgress))+"%")])]):_vm._e(),_vm._v(" "),_c('video',{ref:"video",staticClass:"hero-video",attrs:{"autoplay":"","loop":"","preload":"metadata","playsinline":""},on:{"loadedmetadata":_vm.initializeVideo,"loadeddata":function($event){_vm.videoLoaded = true},"canplaythrough":_vm.videoCanPlayThrough}},[_c('source',{attrs:{"src":_vm.videoFile,"type":"video/mp4"}}),_vm._v("\n      Your browser does not support the video tag.\n    ")]),_vm._v(" "),_c('div',{staticClass:"hero-overlay"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mC4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoFile: "", // Videon polku
      videoLoaded: false, // Lisää tieto video-latauksen tilasta
      loadingProgress: 0 // Latauksen edistyminen prosentteina
    };
  },

  methods: {
    initializeVideo: function initializeVideo() {
      var videoPlayer = this.$refs.video;
      videoPlayer.volume = 0; // Aseta äänenvoimakkuus nollaan
      // Älä aloita videon toistoa tässä
    },
    playVideo: function playVideo() {
      var videoPlayer = this.$refs.video;
      videoPlayer.play();
    },
    videoCanPlayThrough: function videoCanPlayThrough() {
      // Tässä vaiheessa video on ladattu ja voi toistua turvallisesti
      this.playVideo();
    },
    updateLoadingProgress: function updateLoadingProgress() {
      var videoPlayer = this.$refs.video;
      if (videoPlayer) {
        var loaded = videoPlayer.buffered.end(0); // Ladattu osuus videosta
        var duration = videoPlayer.duration; // Videon kesto
        this.loadingProgress = loaded / duration * 100;
      }
    }
  },
  mounted: function mounted() {
    this.videoFile = __webpack_require__("VfpV");

    // Päivitä latauspalkkia 500 millisekunnin välein
    setInterval(this.updateLoadingProgress, 500);
  }
});

/***/ }),

/***/ "nCko":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nI4J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pUJY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fb.216445c.png";

/***/ }),

/***/ "sbwA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vfXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_vue__ = __webpack_require__("8RCM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709a55af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_vue__ = __webpack_require__("J1ig");
function injectStyle (ssrContext) {
  __webpack_require__("bnVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-709a55af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videowall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709a55af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videowall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e0e0ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("eqfr");
function injectStyle (ssrContext) {
  __webpack_require__("2ayk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09e0e0ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e0e0ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wWxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_vm._v(" "),_c('Block1'),_vm._v(" "),_c('Bio'),_vm._v(" "),_c('Videowall'),_vm._v(" "),_c('Songs'),_vm._v(" "),_c('Hero2'),_vm._v(" "),_c('ContactForm'),_vm._v(" "),_c('Faq')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xW/j":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0b62cd58fec19cde3999.js